import { ScoreModel, SportModel } from 'models';
import { PlatformStateInterface } from 'redux/platformSlice';
import { v4 as uuid } from 'uuid';
import laliga from 'assets/images/league_logo/laliga.jpg';
import epl from 'assets/images/league_logo/epl.jpg';
import mls from 'assets/images/league_logo/mls.png';
import NCAAF from 'assets/images/league_logo/NCAAF.png';
import NFL from 'assets/images/league_logo/NFL.png';
import mlb from 'assets/images/league_logo/mlb.png';
import nba from 'assets/images/league_logo/nba.jpg';
import ncaab from 'assets/images/league_logo/ncaab.png';
import nhl from 'assets/images/league_logo/nhl.png';
import wta from 'assets/images/league_logo/WTA.png';
import ufc from 'assets/images/league_logo/ufc.png';
import pga from 'assets/images/league_logo/PGA.png';
import dpt from 'assets/images/league_logo/dpt.jpg';
import atp from 'assets/images/league_logo/atp.png';
import boxing from 'assets/images/league_logo/boxing.png';
import ict from 'assets/images/league_logo/ict_logo.png';
import cpl from 'assets/images/league_logo/CPL_logo.jpg';
import t20 from 'assets/images/league_logo/t20_blast.png';
import lol from 'assets/images/league_logo/lol.png';
import valorant from 'assets/images/league_logo/valorant.png';
import cs2 from 'assets/images/league_logo/cs2.png';
import dota2 from 'assets/images/league_logo/dota2.png';
import c1 from 'assets/images/league_logo/c1.png';
import c2 from 'assets/images/league_logo/c2.png';
import nation_league from 'assets/images/league_logo/nation_league.png';
import vLeague from 'assets/images/league_logo/v_league.png';

import { getLocalStorage } from './sessionStorage';
import { DONT_SHOW_EVENT_AT_DATE_LOCALSTORAGE } from 'consts/app';
import { ScoreBoardResponse } from 'models/genius';

const uniqueId = (): string => Date.now().toString(36) + uuid();

const isEmptyObject = (obj: object): boolean =>
  !obj || (Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype);

const isTablet = (platform: PlatformStateInterface): boolean =>
  platform.isTablet || platform.isSmallTablet || platform.isMediumTablet;

const isPhone = (platform: PlatformStateInterface): boolean =>
  platform.isPhone || platform.isSmallPhone;

const isLaptop = (platform: PlatformStateInterface): boolean => platform.isLaptop;
const capitalizeFirstLetter = (str: string): string => {
  return str.substring(0, 1).toUpperCase() + str.toLowerCase().substring(1);
};

const compareTab = (a: SportModel, b: SportModel): -1 | 1 | 0 => {
  return a.title > b.title ? 1 : a.title < b.title ? -1 : 0;
};

const checkTabSoccer = (tab: string): boolean => {
  return tab === 'EPL' ||
    tab === 'La Liga - Spain' ||
    tab === 'MLS' ||
    tab === 'UEFA Nations League A' ||
    tab === 'UEFA Europa League' ||
    tab === 'UEFA Champions League' ||
    tab === 'Vietnam V.League 1'
    ? true
    : false;
};

const checkTabCricket = (tab: string): boolean => {
  return (
    tab === 'International - Tours' ||
    tab === 'International - Tours Women' ||
    tab === 'West Indies - Caribbean Premier League'
  );
};

const checkTabFootball = (tab: string): boolean => {
  return tab === 'NCAAF' || tab === 'NFL' ? true : false;
};

const checkTabBaseball = (tab: string): boolean => {
  return tab === 'MLB' ? true : false;
};

const checkTabBasketball = (tab: string): boolean => {
  return tab === 'NBA' || tab === 'NCAAB' ? true : false;
};

const checkTabHockey = (tab: string): boolean => {
  return tab === 'NHL' ? true : false;
};

const getLeagueLogo = (name: string): string => {
  switch (name) {
    case 'NCAAF':
      return NCAAF;
    case 'EPL':
      return epl;
    case 'La Liga - Spain':
      return laliga;
    case 'MLS':
      return mls;
    case 'UEFA Champions League':
      return c1;
    case 'UEFA Europa League':
      return c2;
    case 'UEFA Nations League A':
      return nation_league;
    case 'Vietnam V.League 1':
      return vLeague;
    case 'NFL':
      return NFL;
    case 'MLB':
      return mlb;
    case 'NBA':
      return nba;
    case 'NCAAB':
      return ncaab;
    case 'NHL':
      return nhl;
    case 'WTA':
      return wta;
    case 'UFC':
      return ufc;
    case 'PGA':
      return pga;
    case 'DP World Tour':
      return dpt;
    case 'ATP':
      return atp;
    case 'Boxing':
      return boxing;
    case 'International - Tours':
      return ict;
    case 'International - Tours Women':
      return ict;
    case 'West Indies - Caribbean Premier League':
      return cpl;
    case 'England - T20 Blast':
      return t20;
    case 'League of Legends':
      return lol;
    case 'Valorant':
      return valorant;
    case 'CS2':
      return cs2;
    case 'Dota 2':
      return dota2;
    default:
      return '';
  }
};

const getDateWithFormat = (date: string): string => {
  return new Date(date).toLocaleString('en-GB', {
    weekday: 'short', // THU
    hour: 'numeric', // 10
    minute: '2-digit', // 06
    hour12: true, // AM/PM
    // timeZoneName: 'short', // MST
  });
};

const formatDateTime = (date: string | undefined): string => {
  if (!date) {
    return '--';
  }
  return new Date(date).toLocaleString('en-GB', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

const getSuffix = (period: string): string => {
  switch (period) {
    case '1':
      return 'ST';
    case '2':
      return 'ND';
    case '3':
      return 'RD';
    default:
      return 'TH';
  }
};

const getTimeGame = (score: ScoreModel | null, category: string): string => {
  if (!score || !score.period || score.period === 'InProgress') return '';
  const clock = score.clock ? ` - ${score.clock}` : '';
  switch (category) {
    case 'american football':
    case 'football':
      return `Q${score.period}${clock}`;
    case 'basketball':
      return `${score.period} ${clock}`;
    case 'hockey':
    case 'ice hockey':
      return `${score.period}`;
    default:
      return `${score.period}${clock}` || '';
  }
};

const checkMoreSportActive = (currentCategory: string | null): boolean => {
  return (
    currentCategory === 'tennis' ||
    currentCategory === 'golf' ||
    currentCategory === 'mma' ||
    currentCategory === 'cricket' ||
    currentCategory === 'esports'
  );
};

const checkPlayerPropsActive = (currentCategory: string | null): boolean => {
  return (
    currentCategory === 'football' ||
    currentCategory === 'basketball' ||
    currentCategory === 'hockey' ||
    currentCategory === 'baseball' ||
    currentCategory === 'esports'
  );
};

const checkMoreSportActiveWithTab = (tab: string): boolean => {
  return (
    tab === 'DP World Tour' ||
    tab === 'PGA' ||
    tab === 'UFC' ||
    tab === 'League of Legends' ||
    tab === 'Valorant' ||
    tab === 'CS2' ||
    tab === 'Dota 2' ||
    tab === 'ATP' ||
    tab === 'ATP French Open' ||
    tab === 'ATP Santa Fe Challenger' ||
    tab === 'ATP Lyon Challenger' ||
    tab === 'ATP Stuttgart' ||
    tab === 'ATP Ilkley Challenger' ||
    tab === 'ATP Perugia Challenger' ||
    tab === 'ATP Hertogenbosch' ||
    tab === 'ATP Bratislava Challenger' ||
    tab === 'WTA' ||
    tab === 'WTA French Open' ||
    tab === 'WTA London' ||
    tab === 'WTA Hertogenbosch'
  );
};

const shortenAddress = (address?: string): string => {
  if (!address) return '--';
  return `${address.slice(0, 6)}...${address.slice(address.length - 5, address.length - 1)}`;
};

const isShowEventNoti = () => {
  const lastTime = getLocalStorage(DONT_SHOW_EVENT_AT_DATE_LOCALSTORAGE);
  if (lastTime) {
    const lastTimeDate = new Date(lastTime);
    const currentTime = new Date();
    return currentTime.getDate() !== lastTimeDate.getDate();
  }
  return true;
};

const checkEmptyString = (text: string): boolean => {
  return text.replace(' ', '') === '';
};

const openPopup = (link: string) => {
  const popup = window.open(link, 'PopupWindow', 'width=600,height=400');
  if (popup) {
    popup.focus();
  }
};

const WITHDRAW_MEMO_CHAIN = ['XLM', 'TON'];

const getPhaseText = (category: string, additionData: ScoreBoardResponse): string => {
  const summaries = additionData?.multiSportScoreBoardData?.matchSummaries;
  const phase = summaries?.phase || '';
  const currentPhase = summaries?.currentPhase || '';

  if (category === 'tennis') {
    const phaseLower = phase.toLowerCase();

    if (phaseLower.startsWith('set')) {
      return phase || currentPhase || '--';
    } else {
      return '--';
    }
  } else {
    return phase || currentPhase || '--';
  }
};

export {
  uniqueId,
  isEmptyObject,
  isTablet,
  isPhone,
  isLaptop,
  capitalizeFirstLetter,
  compareTab,
  checkTabSoccer,
  getLeagueLogo,
  getDateWithFormat,
  getTimeGame,
  checkTabBaseball,
  checkTabBasketball,
  checkTabFootball,
  checkTabHockey,
  checkMoreSportActive,
  checkMoreSportActiveWithTab,
  shortenAddress,
  checkPlayerPropsActive,
  isShowEventNoti,
  checkEmptyString,
  openPopup,
  checkTabCricket,
  WITHDRAW_MEMO_CHAIN,
  formatDateTime,
  getPhaseText,
};
